import { render, staticRenderFns } from "./SwappTasksListForm.vue?vue&type=template&id=6e9c18d8&scoped=true"
import script from "./SwappTasksListForm.vue?vue&type=script&lang=js"
export * from "./SwappTasksListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c18d8",
  null
  
)

export default component.exports